module.exports = __webpack_public_path__ + "media/coaching-1080.99f61208.mp4";